// Basis API-Konfiguration für GKS Backend
import axios from 'axios';
import { AUTH_STORAGE_KEYS } from '../types/auth';

// Basis-URL für das Spring Boot Backend
// In Docker: Nginx proxyt /api/* an das Backend
// Lokal (dev): Verwendet localhost:8080 oder REACT_APP_API_URL
const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const redirectToLogin = () => {
  localStorage.removeItem(AUTH_STORAGE_KEYS.token);
  localStorage.removeItem(AUTH_STORAGE_KEYS.user);
  if (typeof window !== 'undefined' && window.location.pathname !== '/login') {
    window.location.href = '/login';
  }
};

// Axios-Instanz mit Basis-Konfiguration
export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

// Request Interceptor für Logging
apiClient.interceptors.request.use(
  (config) => {
    // Auth-Token aus LocalStorage anhängen, falls vorhanden
    const token = localStorage.getItem(AUTH_STORAGE_KEYS.token);
    if (token) {
      config.headers = config.headers || {};
      (config.headers as any)['Authorization'] = `Bearer ${token}`;
    }
    console.log(`API Request: ${config.method?.toUpperCase()} ${config.url}`);
    return config;
  },
  (error) => {
    console.error('API Request Error:', error);
    return Promise.reject(error);
  }
);

// Response Interceptor für Error Handling
apiClient.interceptors.response.use(
  (response) => {
    console.log(`API Response: ${response.status} ${response.config.url}`);
    return response;
  },
  (error) => {
    console.error('API Response Error:', error.response?.data || error.message);
    
    // Globale Error-Behandlung
    if (error.response?.status === 401) {
      console.error('Unauthorized - Authentifizierung erforderlich');
      // Token ungültig: lokalen Zustand bereinigen und zur Login-Seite navigieren
      redirectToLogin();
    } else if (error.response?.status === 403) {
      console.error('Forbidden - Keine Berechtigung');
      console.error('Behandle 403 als abgelaufenen Auth-Token - Benutzer wird abgemeldet');
      redirectToLogin();
    } else if (error.response?.status === 404) {
      console.error('Not Found - Ressource nicht gefunden');
    } else if (error.response?.status >= 500) {
      console.error('Server Error - Interner Serverfehler');
    }
    
    return Promise.reject(error);
  }
);

export default apiClient;
